import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl-next';
import { getTrigger, isNewTab } from '../../../common/analytics';
import { AdvancedSearchLinkSubjectId } from '../../../common/analytics/events';
import { messages } from '../../../messages';
import { useQuery } from '../../query-context';
import { AdvancedSearchContainer, LabelContainer, StyledLink } from './single-site-advanced-search.styled';
export const getSearchConfiguration = (query, features) => {
  let allLinks = {
    board: {
      href: `/secure/ManageRapidViews.jspa?contains=${query}`,
      message: messages.jira_advanced_search_boards,
      actionSubjectId: AdvancedSearchLinkSubjectId.JIRA_BOARDS
    },
    project: {
      href: `/projects?contains=${query}`,
      message: messages.jira_advanced_search_projects,
      actionSubjectId: AdvancedSearchLinkSubjectId.JIRA_PROJECTS
    },
    filters: {
      href: `/secure/ManageFilters.jspa?Search=Search&filterView=search&name=${query}`,
      message: messages.jira_advanced_search_filters,
      actionSubjectId: AdvancedSearchLinkSubjectId.JIRA_FILTERS
    },
    plans: {
      href: `/jira/plans`,
      message: messages.jira_advanced_search_plans,
      actionSubjectId: AdvancedSearchLinkSubjectId.JIRA_PLANS
    },
    people: {
      href: `/jira/people/search?q=${query}`,
      message: messages.jira_advanced_search_people,
      actionSubjectId: AdvancedSearchLinkSubjectId.JIRA_PEOPLE
    }
  };

  // Remove access to plans if the user does not have Advanced Roadmaps access
  if (!(features !== null && features !== void 0 && features.hasAdvancedRoadmapsAccess)) {
    delete allLinks.plans;
  }
  // Remove access to boards if the user does not have software access
  if (!(features !== null && features !== void 0 && features.hasAdvancedRoadmapsAccess) && !(features !== null && features !== void 0 && features.hasSoftwareAccess)) {
    delete allLinks.board;
  }
  return allLinks;
};
export const SingleSiteAdvancedSearch = ({
  advancedSearchSelected,
  features,
  linkComponent
}) => {
  const {
    query,
    isLoading
  } = useQuery();
  const onClickAndFireEvent = (e, actionSubjectId) => {
    e.preventDefault();
    advancedSearchSelected({
      actionSubjectId,
      trigger: getTrigger(e),
      isLoading,
      newTab: isNewTab(e)
    });
  };
  const searchConfiguration = getSearchConfiguration(query, features);
  return /*#__PURE__*/React.createElement(AdvancedSearchContainer, null, /*#__PURE__*/React.createElement(LabelContainer, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.jira_advanced_search_label)), Object.keys(searchConfiguration).map(key => {
    const {
      href,
      message,
      actionSubjectId
    } = searchConfiguration[key];
    return /*#__PURE__*/React.createElement("span", {
      onClick: e => onClickAndFireEvent(e, actionSubjectId),
      role: "none",
      style: {
        height: '100%'
      }
    }, /*#__PURE__*/React.createElement(StyledLink, {
      linkComponent: linkComponent,
      key: `search_link_${key}`,
      href: href
    }, /*#__PURE__*/React.createElement(FormattedMessage, message)));
  }));
};
export default injectIntl(SingleSiteAdvancedSearch);